import { render } from "./UpdateSubModules.vue?vue&type=template&id=5a7cb35e"
import script from "./UpdateSubModules.vue?vue&type=script&lang=js"
export * from "./UpdateSubModules.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__